import { useMemo } from 'react';
import { object, string } from 'yup';

export function useSettingSchema() {
    return useMemo(
        () =>
            object().shape({
                organisationId: string().required(),
                shipmentMailSubject: string().required(),
                shipmentMailBody: string().required(),
            }),
        [],
    );
}
